import ServerInstance from "./server.api";

class AuthEndpoint extends ServerInstance {
    async verifySession() {
        try {
            await this.get("auth/session");
        } catch (error) {
            throw error;
        }
    }

    async getCurrentUser() {
        try {
            const response = await this.get("auth/me");
            return response;
        } catch (error) {
            throw error;
        }
    }

    async register(data) {
        try {
            const response = await this.post("auth/register", data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async requestOtp(data) {
        try {
            const response = await this.post("auth/request-otp", data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async login(data) {
        try {
            const response = await this.post("auth/validate-otp", data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async logout() {
        try {
            await this.post("auth/logout");
        } catch (error) {
            throw error;
        }
    }
}

export default AuthEndpoint;
